import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { DimensionsListenerDirective } from '@games/shared/game-dynamic-blocks/dimensions-listener.directive';

@Component({
    selector: 'ms-speed-reading-footer-button, [ms-speed-reading-footer-button]',
    templateUrl: './speed-reading-footer-button.component.html',
    styleUrls: ['./speed-reading-footer-button.component.scss'],
    hostDirectives: [DimensionsListenerDirective],
    standalone: false
})
export class SpeedReadingFooterButtonComponent {
  parentStyles: Partial<CSSStyleDeclaration> = {};

  wrapperStyles: Partial<CSSStyleDeclaration> = {
    fontSize: '0px',
  };

  contentStyles: Partial<CSSStyleDeclaration> = {};

  constructor(
    private readonly _dimensionsListener: DimensionsListenerDirective,
    private readonly _cdr: ChangeDetectorRef,
    private readonly _elementRef: ElementRef,
  ) {
    // debugger;
    this._dimensionsListener.sizeChanges.subscribe((res) => {
      this.adjust(res.width, res.height);
    });
    // this.adjust(_elementRef.nativeElement.offsetWidth, _elementRef.nativeElement.offsetHeight);
  }

  adjust(width: number, height: number) {
    this.wrapperStyles = {
      fontSize: height * 0.012 + 'px',
    };
    this._cdr.markForCheck();
  }
}
